import { colors, fontSizes } from '../consts'
import { styled } from '@mui/system'
import { Link } from 'react-router-dom'

type CardProps = {
  height?: number
  cardType: 'leader' | 'roster' | 'coach'
}
export const CardCon = styled('div')<CardProps>(({ height = 300, cardType, theme }) => ({
  width: cardType === 'leader' ? 200 : cardType === 'roster' ? 200 : 200,
  height: cardType === 'leader' ? 250 : cardType === 'roster' ? 350 : height,
  border: `1px solid ${colors.lightGrey}`,
  display: 'inline-flex',
  flexDirection: 'column',
  borderRadius: theme.spacing(1),
  [theme.breakpoints.between('md', 'lg')]: {
    width: cardType === 'leader' ? 200 : cardType === 'roster' ? 200 : height * 0.9,
    height: cardType === 'leader' ? 250 : cardType === 'roster' ? 350 : height,
  },
  [theme.breakpoints.between('sm', 'md')]: {
    width: cardType === 'leader' ? 180 : cardType === 'roster' ? 180 : height * 0.9,
    height: cardType === 'leader' ? 230 : cardType === 'roster' ? 350 : height,
  },
  [theme.breakpoints.between('xs', 'sm')]: {
    width: cardType === 'leader' ? 180 : cardType === 'roster' ? 180 : height * 0.8,
    height: cardType === 'leader' ? 210 : cardType === 'roster' ? 350 : height,
  },
  [theme.breakpoints.down('xs')]: {
    width: cardType === 'leader' ? 180 : cardType === 'roster' ? 180 : height * 0.8,
    height: cardType === 'leader' ? 210 : cardType === 'roster' ? 350 : height,
  },
  '& a': {
    textDecoration: 'none',
    color: '#242424',
  },
  '& .innerPad': {
    padding: theme.spacing(1, 1, 0, 1),
    flexGrow: 1,
    '& img': {
      width: '100%',
      height: 150,
      objectFit: 'cover',
      objectPosition: '0 -5px',
      borderRadius: theme.spacing(1),
      [theme.breakpoints.down('sm')]: {
        height: 130,
      },
    },
    // name for coach card
    '& .coachNameRow': {
      marginTop: theme.spacing(1),
      marginBottom: theme.spacing(2),
      '& .firstName': {
        fontSize: '13px',
        lineHeight: '14px',
      },
      '& .lastName': {
        fontSize: '13px',
        lineHeight: '14px',
        fontWeight: 'bold',
      },
    },
    '& .coachSummary': {
      fontSize: '11px',
      color: colors.text,
      marginBottom: theme.spacing(2),
    },
  },
}))

export const LeaderHeadCon = styled('div')(({ theme }) => ({
  fontSize: fontSizes.medium,
  fontWeight: 'bold',
  color: colors.text,
  padding: theme.spacing(1),
  textAlign: 'center',
  borderBottom: `1px solid ${colors.lightGrey}`,
}))

export const PlayerNameRow = styled('div')(({ theme }) => ({
  margin: theme.spacing(1, 0.5),
  display: 'grid',
  gridTemplateColumns: 'auto 1fr 28px',
  gridTemplateAreas: '"p fn fl" "p ln fl"',
  '& .number': {
    gridArea: 'p',
    paddingRight: theme.spacing(1),
    borderRight: `1px solid ${colors.lightGrey}`,
    // small margin for fav star
    '& .favMargin': { marginRight: theme.spacing(0.5) },
    '& .points': {
      letterSpacing: -1,
      fontWeight: 'bold',
      fontSize: '28px',
      lineHeight: '33px',
    },
  },
  '& .firstName': {
    gridArea: 'fn',
    fontSize: '13px',
    marginLeft: theme.spacing(1),
  },
  '& .lastName': {
    gridArea: 'ln',
    fontSize: '13px',
    fontWeight: 'bold',
    marginLeft: theme.spacing(1),
  },
  '& img.flag': {
    gridArea: 'fl',
    height: 20
  },
}))

export const StatsRow = styled('div')(({ theme }) => ({
  fontSize: 11,
  margin: theme.spacing(1, 0.5),
  '& div': {
    borderBottom: `1px solid ${colors.lightGrey}`,
    padding: '2px 0',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    '& > span:last-child': {
      textAlign: 'right',
      marginLeft: 6,
    },
    '&:last-child': {
      borderBottom: 0,
    },
  },
}))

export const LeaderInner = styled('div')(({ theme }) => ({
  padding: theme.spacing(1),
  flexGrow: 1,
  textAlign: 'center',
  '& .leaderTextCon': {
    fontWeight: 500,
    '& p': {
      marginTop: 3,
      fontSize: '0.7rem',
      fontWeight: 300,
      color: '#242424',
    },
    '& .points': {
      letterSpacing: -1,
      fontWeight: 'bold',
      fontSize: '28px',
      lineHeight: '33px',
    },
  },
}))

export const CoachOuter = styled('div')(({ theme }) => ({
  margin: theme.spacing(1)
}))

export const CoachRow = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  flexWrap: 'wrap',
  '& .coachesCol': {
    margin: theme.spacing(1),
  },
}))

export const Footer = styled('div')(({ theme }) => ({
  backgroundColor: colors.lightGrey,
  borderBottomLeftRadius: theme.spacing(1),
  borderBottomRightRadius: theme.spacing(1),
  fontSize: 11,
  textAlign: 'center',
  padding: '5px 9px',
}))

export const BioLink = styled(Link)(({ theme }) => ({
  fontWeight: 'bold',
  color: '#000',
  textDecoration: 'none',
}))

export const TeammateCon = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  minWidth: 240,
  color: colors.text,
  textDecoration: 'none',
  '& img': {
    width: 78,
    height: 78,
    margin: 0,
  },
  '& .num': {
    fontSize: fontSizes.large,
    fontWeight: 'bold',
    marginLeft: theme.spacing(2),
    marginRight: theme.spacing(2),
    paddingRight: theme.spacing(2),
    borderRight: `1px solid ${colors.text}`,
  },
  '& .name': {
    lineHeight: '120%',
    '& span': {
      fontWeight: 'bold',
      fontSize: '110%',
    },
  },
}))
